import React, { createContext, useContext } from 'react';
import type { ReactNode } from 'react';

type Config = string | null;
type ProviderProps = Context & { children: ReactNode };

export type Context = {
  API_ROOT: Config,
  APP_STAGE: Config,
  bootstrap: Record<string, any> | null,
  BUGSNAG_API_KEY: Config,
  GTM_ID: Config,
  NODE_PATH: Config,
  PUBLIC_URL: Config,
  S3_URL: Config,
};

export const ConfigContext = createContext<Context>({
  API_ROOT: null,
  APP_STAGE: null,
  bootstrap: null,
  BUGSNAG_API_KEY: null,
  GTM_ID: null,
  NODE_PATH: null,
  PUBLIC_URL: null,
  S3_URL: null,
});

export const ConfigProvider = ({ children, ...rest }: ProviderProps) => {
  return <ConfigContext.Provider value={{ ...rest }}>{children}</ConfigContext.Provider>;
};

export const useConfig = () => {
  return useContext(ConfigContext);
};
